var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{class:_vm.classes,attrs:{"hide-details":"auto","error-messages":_vm.errorMessages}},[_c('fieldset',{attrs:{"aria-hidden":"true"}},[_c('legend',{style:({ width: (_vm.legendWidth + "px") })},[_c('span',{staticClass:"notranslate"},[_vm._v("​")])])]),_c('label',{class:{
      'v-label': true,
      'v-label--active': true,
      'theme--light': true,
      'error--text': _vm.errorMessages.length
    },staticStyle:{"right":"auto","position":"absolute"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }